import type {Builder} from '@wix/document-services-types'
import {STYLE} from '@wix/component-protocol/schema' // eslint-disable-line wix-editor/no-internal-import

interface CSSVariableData {
    type: string
    value: string | number
}

const isVariableData = (value: unknown): value is CSSVariableData => {
    return typeof value === 'object' && value !== null && 'type' in value && 'value' in value
}

const normalizeVariableLengthValue = (value: CSSVariableData): string => {
    return value.type === 'percentage' ? `${value.value}%` : `${value.value}${value.type}`
}

// temporarily mapping, while we don't have a full mapping
export const convertDMVariableToCSSValue = (styleItem: Builder.StyleItem, value: unknown) => {
    if (!styleItem.cssVariableType || !isVariableData(value)) {
        return value
    }

    switch (styleItem.cssVariableType) {
        case STYLE.CSS_VARIABLE_TYPE.length:
            return normalizeVariableLengthValue(value)
        case STYLE.CSS_VARIABLE_TYPE.number:
            return value.value.toString()
        case STYLE.CSS_VARIABLE_TYPE.percentage:
            return `${value.value}%`
        default:
            return value.value
    }
}
